<template>
    <div>
        <div v-if="svgLoading">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="margin:auto;background:#fff;display:block;"
                width="150px"
                height="150px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
            >
                <g transform="rotate(0 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.9166666666666666s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(30 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.8333333333333334s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(60 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.75s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(90 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.6666666666666666s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(120 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.5833333333333334s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(150 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.5s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(180 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.4166666666666667s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(210 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.3333333333333333s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(240 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.25s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(270 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.16666666666666666s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(300 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="-0.08333333333333333s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
                <g transform="rotate(330 50 50)">
                    <rect x="46.5" y="24" rx="3.5" ry="6" width="7" height="12" fill="#71abfe">
                        <animate
                            attributeName="opacity"
                            values="1;0"
                            keyTimes="0;1"
                            dur="1s"
                            begin="0s"
                            repeatCount="indefinite"
                        ></animate>
                    </rect>
                </g>
            </svg>
            <hr />
        </div>
        <svg v-show="showGraph" id="svg" viewBox="0,0,600,260" height="260" width="100%">
            <line
                x1="0"
                y1="0"
                x2="0"
                y2="100%"
                stroke-dasharray="5, 5"
                stroke="black"
                stroke-width="1px"
            ></line>
            <circle cx="0" cy="7" r="5" style="fill: #D74854"></circle>
            <text x="10" y="12">Negative</text>

            <line
                x1="50%"
                y1="0"
                x2="50%"
                y2="100%"
                stroke-dasharray="5, 5"
                stroke="black"
                stroke-width="1px"
            ></line>
            <circle cx="50%" cy="7" r="5" style="fill: #F09E38"></circle>
            <text x="51%" y="11">Neutral</text>

            <line
                x1="100%"
                y1="0"
                x2="100%"
                y2="100%"
                stroke-dasharray="5, 5"
                stroke="black"
                stroke-width="1px"
            ></line>
            <circle cx="100%" cy="7" r="5" style="fill: #64C2AC"></circle>
            <text dx="-70" x="100%" y="11">Positive</text>
        </svg>
    </div>
</template>

<script>
import * as d3 from "d3";
import forceBoundary from "d3-force-boundary";

// start of D3 plugins

// this funciton increase the bubble untile any of the bubbles reach the boundary.
function forceBubbleSize(width, height) {
    var nodes;
    function force() {
        for (var i = 0, n = nodes.length, node; i < n; ++i) {
            node = nodes[i];
            if (node.x + node.r > width) {
                // there are bubbles(s) reaching right
                return;
            }
            if (node.x - node.r < 0) {
                // there are bubbles(s) reaching left
                return;
            }
            if (node.y - node.r < 0) {
                // there are bubble(s) reaching top
                return;
            }
            if (node.y + node.r > height) {
                // there are bubble(s) reaching bottom
                return;
            }
        }
        // eslint-disable-next-line no-redeclare
        for (var i = 0, n = nodes.length, node; i < n; ++i) {
            node = nodes[i];
            node.r += 1 * Math.sqrt(node.percentage / 100, 2); // increase all the bubble, we have to use Math.sqrt cause visual the bubble size will respect its precentage.
        }
    }

    function initialize() {
        if (!nodes) return;
    }

    force.initialize = function(_) {
        nodes = _;
        initialize();
    };

    return force;
}

// this is just a modified copy of  https://github.com/d3/d3-force/blob/master/src/collide.js
// the modified version check the r of the bubble because we are changing it to make sure it fit in our canvas.
function constant(x) {
    return function() {
        return x;
    };
}

function x(d) {
    return d.x + d.vx;
}

function y(d) {
    return d.y + d.vy;
}

function forceCollide(radius) {
    var nodes,
        // random,
        strength = 1,
        iterations = 1;

    if (typeof radius !== "function") radius = constant(radius == null ? 1 : +radius);

    function force() {
        var i,
            n = nodes.length,
            tree,
            node,
            xi,
            yi,
            ri,
            ri2;
        for (var k = 0; k < iterations; ++k) {
            tree = d3.quadtree(nodes, x, y).visitAfter(prepare);
            for (i = 0; i < n; ++i) {
                node = nodes[i];
                (ri = node.r), (ri2 = ri * ri); // MODIFIED, we are geting r from the node, because r is changing
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }

        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data,
                rj = quad.r,
                r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx,
                        y = yi - data.y - data.vy,
                        l = x * x + y * y;
                    if (l < r * r) {
                        // leave this alone since our x and y shouldn't be 0 for now.
                        // if (x === 0) x = jiggle(random), l += x * x;
                        // if (y === 0) y = jiggle(random), l += y * y;
                        l = ((r - (l = Math.sqrt(l))) / l) * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }

    function prepare(quad) {
        if (quad.data) return (quad.r = quad.data.r); // MODIFIED again, getting r from the node.
        for (var i = (quad.r = 0); i < 4; ++i) {
            if (quad[i] && quad[i].r > quad.r) {
                quad.r = quad[i].r;
            }
        }
    }

    function initialize() {
        if (!nodes) return;
    }

    force.initialize = function(_nodes) {
        nodes = _nodes;
        // random = _random;
        initialize();
    };

    force.iterations = function(_) {
        return arguments.length ? ((iterations = +_), force) : iterations;
    };

    force.strength = function(_) {
        return arguments.length ? ((strength = +_), force) : strength;
    };

    force.radius = function(_) {
        return arguments.length
            ? ((radius = typeof _ === "function" ? _ : constant(+_)), initialize(), force)
            : radius;
    };

    return force;
}

//end of d3 plugins

export default {
    components: {},
    props: {
        topics: {
            type: Array,
            required: true,
        },
        width: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            svgLoading: true,
            filterOptions: {},
            simulation: null,
        };
    },

    computed: {
        showGraph() {
            const show = !this.svgLoading && Array.isArray(this.topics) && this.topics.length;

            // make sure our parent component is aware
            if (!show) {
                this.$emit("hide");
            } else {
                this.$emit("show");
            }

            return show;
        },
    },
    watch: {
        topics: {
            immediate: true,
            handler() {
                if (document.getElementById("svg")) {
                    this.loadBubbleGraph();
                }
            },
        },
    },
    mounted() {
        this.loadBubbleGraph();
    },
    methods: {
        loadBubbleGraph() {
            const { topics, simulation, width } = this;

            // document.querySelector(".card-block").clientWidth - 50;
            const height = 0.3 * width;

            simulation && simulation.stop(); // there might be simulation still running.
            this.tooltip && this.tooltip.remove(); // remove tooltip created from previous chart

            if (topics && topics.length) {
                this.svgLoading = true; // show a loading svg first
            } else {
                // no data, hide the graph, in the case of to many filter etc
                this.svgLoading = false;
                this.$forceUpdate();
                return;
            }

            const svg = d3.select("#svg");
            svg.selectAll("g").remove();
            svg.attr("viewBox", [0, 0, width, height]);
            svg.attr("height", height);
            svg.attr("width", "100%");

            const scoreArray = topics.map(t => t.score);
            const scoreSum = scoreArray.reduce((a, b) => a + b, 0);

            const nodesData = topics
                .filter(t => t.score > 0)
                .map(data => ({
                    // this equals to return {...data,  r, y...}
                    ...data,
                    r: Math.sqrt(data.score / scoreSum) * 1, // percentage of the bubble * half height
                    y: 200,
                    color: perc2color(((data.positive - data.negative + 1) / 2) * 100),
                    label: data.category,
                    sentiment: data.positive - data.negative,
                    percentage: Math.floor((data.score / scoreSum) * 100),
                }));

            const nodes = svg
                .append("g")
                .selectAll("circle")
                .data(nodesData)
                .join("g")
                .style("cursor", "pointer");

            // set the cycle's color and radius
            nodes
                .append("circle")
                .style("fill", d => d.color)
                .attr("r", d => d.r);

            // create a tooltip so it shows extra info when hover on it.
            this.tooltip = d3
                .select("body")
                .append("div")
                .style("position", "absolute")
                .style("z-index", "10")
                .style("visibility", "hidden")
                .style("color", "#000");

            svg.selectAll("g")
                .on("mouseover", p => {
                    if (!p) {
                        return;
                    }
                    const { label, percentage } = p.target.__data__;
                    this.tooltip.text(`${label} (${percentage}%)`);
                    return this.tooltip.style("visibility", "visible");
                })
                .on("mousemove", event => {
                    return this.tooltip
                        .style("top", event.pageY - 10 + "px")
                        .style("left", event.pageX + 10 + "px");
                })
                .on("mouseout", () => {
                    return this.tooltip.style("visibility", "hidden");
                })
                .on("click", (p, d) => {
                    if (!p) {
                        return;
                    }
                    p.stopPropagation();

                    if (!d) {
                        return;
                    }
                    this.$emit("click", d);
                });

            const tick = () => {
                nodes.attr("transform", cycleTranslate);
                nodes.select("circle").attr("r", d => d.r);
            };
            // this is the magic that moves our cycle around and eventually force them stick together and not break the rule
            this.simulation = d3
                .forceSimulation(nodesData)
                .on("tick", tick)
                .on("end", () => {
                    // this function will be triggered once the simulation is stopped,
                    // we only want to show the graph after all the bubble are corrected positioned.
                    this.svgLoading = false; // hide the loading svg
                    this.$forceUpdate();
                    // show percentage of the cycle.
                    setTimeout(() => {
                        nodes
                            .append("text")
                            .attr("dy", ".3em")
                            .style("text-anchor", "middle")
                            .style("color", "black")
                            .text(p => (p.r >= 10 ? p.label : ""))
                            .each(function(p) {
                                var padding = 2;
                                var self = d3.select(this),
                                    textLength = self.node().getComputedTextLength(),
                                    text = self.text();
                                if (textLength == 0) {
                                    self.text("");
                                }
                                while (textLength > p.r * 2 - 2 * padding && text.length > 0) {
                                    text = text.slice(0, -1);
                                    if (text.length > 0) {
                                        self.text(text + "...");
                                    } else {
                                        self.text("");
                                    }

                                    textLength = self.node().getComputedTextLength();
                                }
                            }); // this add text on the bubble add ... at the end if the text is too long
                    }, 500);
                })
                .force(
                    "collide",
                    // use our own version of forceCollide
                    forceCollide()
                        .radius(d => 10 + d.r) // social distance
                        .iterations(3)
                        .strength(2),
                )
                .force(
                    "x",
                    d3
                        .forceX()
                        .x(function(p) {
                            var x = ((p.sentiment + 1) / 2) * width;
                            /* make sure cycle won't get cut at the end */
                            // FIXME this is not prefect yet.
                            if (x + p.r >= width) {
                                x = width - p.r;
                            }
                            return x;
                        })
                        .strength(1),
                )
                .force(
                    "y",
                    d3.forceY().y(() => height / 2),
                )
                .force("boundary", forceBoundary(30, 30, width - 30, height - 30))
                .force("size", forceBubbleSize(width, height))
                .stop();

            const cycleTranslate = p => {
                // console.log("cycleTranslate", p)
                return `translate(${p.x}, ${p.y})`;
            };

            // differ application of the forces
            setTimeout(() => {
                this.simulation.restart();
                nodes.transition().attr("transform", cycleTranslate);
            }, 2000);

            tick();
            // TODO image download

            function perc2color(perc) {
                var colors = [
                    "#D74854",
                    "#FF717D",
                    "#FF909A",
                    "#FF9E65",
                    "#FFBA65",
                    "#FFBA65",
                    "#FFCF94",
                    "#90E4D1",
                    "#70DAC1",
                    "#64C2AC",
                ];
                return colors[Math.floor(perc / 10)];
            }
        },
    },
};
</script>

<style scoped></style>
